// extracted by mini-css-extract-plugin
module.exports = {"dwgWrap":"index_dwgWrap__37lHP","dwgLoadingContainer":"index_dwgLoadingContainer__bHptN","loadingTitle":"index_loadingTitle__2KF74","dwgContainer":"index_dwgContainer__1tTYk"};